// extracted by mini-css-extract-plugin
export default {"comment":"CommentResultCard-module__comment--cprzJ","context":"CommentResultCard-module__context--NPYzL","animatedBackground":"CommentResultCard-module__animatedBackground--9A9AT"};